import React, {useEffect, useState} from "react";
import {Button, FormControl, FormHelperText, TextField, Tooltip} from "@mui/material";
import {nzcarInfoMessageCommunity} from "../Landing/nzcarInfoMessage";
import {MdInfo} from "react-icons/md";

export default function CommunityStep1({postcode,setPostCode,aStep, setAStep, frmFn, setFrmFn, frmLn, setFrmLn, frmStreet, setFrmStreet, frmStreetNumber, setFrmStreetNumber, frmCity, setFrmCity, frmEmail, setFrmEmail, frmPhone, setFrmPhone, userAccount}) {

    const [emailConfirm, setEmailConfirm] = useState(frmEmail || '');
    const [emailValid, setEmailValid] = useState(false);
    const [phoneValid, setPhoneValid] = useState(false);
    const emailLabel = 'Email*';

    useEffect(() => {
        // console.log(userAccount)
        const nme = String(userAccount.name).split(" ");
    }, []);


    useEffect(() => {
        setEmailValid(
            validateEmail(frmEmail)
        );

        setPhoneValid(
            validatePhone(frmPhone)
        );
    });


    function validateEmail(email) {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    function validatePhone(phone) {

        // let valNew = String(phone).replace(/null/g,'');
        // valNew = String(valNew).replace(/\s/g,'');
        // valNew = String(valNew).replace(/-/g,'');
        // valNew = String(valNew).replace(/\(/g,'');
        // valNew = String(valNew).replace(/\)/g,'').trim();
        let rePhone = /^(((\+64\s*[-\.]?[3-9]|\(?0[3-9]\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{4})|((\+?64\s*[-\.\(]?2\d{1}[-\.\)]?|\(?02\d{1}\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{3,5})|((\+?64\s*[-\.]?[-\.\(]?800[-\.\)]?|[-\.\(]?0508[-\.\)]?|[-\.\(]?0800[-\.\)]?)\s*[-\.]?\d{3}\s*[-\.]?(\d{3,4}|\d{6,7})))$/;
        return !((!rePhone.test(phone) && phone !== '') || phone === '');
    }

    return (
        <div>
            <div className={"form"}>

                <h3 style={{marginBottom: 20}}>Please enter owner details.</h3>

                <FormControl fullWidth sx={{marginBottom: 1}}>
                    <TextField
                        error={(frmFn === '')}
                        label="First name*"
                        type="text"
                        value={frmFn}
                        onChange={(e) => setFrmFn(e.target.value)}
                        focused
                    />
                </FormControl>

                <FormControl fullWidth sx={{marginBottom: 1}}>
                    <TextField
                        error={(frmLn === '')}
                        label="Last name*"
                        type="text"
                        value={frmLn}
                        onChange={(e) => setFrmLn(e.target.value)}
                        focused
                    />

                </FormControl>

                <div style={{display:'flex', flex:'1 0 100%'}}>
                    <FormControl fullWidth sx={{marginBottom: 1, marginRight:1}}>
                        <TextField
                            label="Street number"
                            type="text"
                            value={frmStreetNumber}
                            onChange={(e) => setFrmStreetNumber(e.target.value)}
                            focused
                            disabled
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{marginBottom: 1}}>
                        <TextField
                            label="Street"
                            type="text"
                            value={frmStreet}
                            onChange={(e) => setFrmStreet(e.target.value)}
                            focused
                            disabled
                        />
                    </FormControl>
                </div>
                <FormControl fullWidth sx={{marginBottom: 1}}>
                    <TextField
                        label="City"
                        type="text"
                        value={frmCity}
                        onChange={(e) => setFrmCity(e.target.value)}
                        focused
                        disabled
                    />
                </FormControl>
                <FormControl fullWidth sx={{marginBottom: 1}}>
                    <TextField
                        value={postcode}
                        label="Postcode"
                        type="text"
                        disabled
                    />
                </FormControl>

                <FormControl fullWidth sx={{marginBottom: 1}}>
                    <TextField
                        error={!emailValid}
                        label={emailLabel}
                        type="email"
                        aria-describedby="email-helper-text"
                        value={frmEmail}
                        onChange={(e) => setFrmEmail(e.target.value)}
                        focused
                    />
                    <FormHelperText id="email-helper-text">
                        We need an email address to send the voucher confirmation.
                        <Tooltip title={nzcarInfoMessageCommunity}>
                            <a><MdInfo size={18} /></a>
                        </Tooltip>
                    </FormHelperText>
                </FormControl>

                <FormControl fullWidth sx={{marginBottom: 1}}>
                    <TextField
                        error={(emailConfirm === '' || frmEmail === '' || frmEmail !== emailConfirm)}
                        label="Confirm owner's email*"
                        type="email"
                        aria-describedby="email-helper-text-confirm"
                        value={emailConfirm}
                        onChange={(e) => setEmailConfirm(e.target.value)}
                        focused
                    />
                    <FormHelperText id="email-helper-text-confirm">
                        Please confirm the email address again.
                    </FormHelperText>
                </FormControl>

                <FormControl fullWidth sx={{marginBottom: 1}}>
                    <TextField
                        error={(frmPhone === '' || !phoneValid)}
                        label="Phone number*"
                        type="phone"
                        aria-describedby="component-helper-text"
                        value={frmPhone}
                        onChange={(e) => setFrmPhone(e.target.value)}
                        focused
                    />
                    {(!phoneValid) ? <small style={{color:'red'}}>Please provide a valid NZ phone number</small> : undefined}
                    <FormHelperText id="component-helper-text">
                        Please ensure that the owner is aware that their phone number will be provided to the Vet Clinic for booking purposes and that if needed, we may also use this phone number to confirm their details.
                    </FormHelperText>
                </FormControl>

                <Button size="small"
                        onClick={() => {
                            setAStep(aStep + 1);
                            window.gtag('event', 'action', {
                                category: 'User',
                                action: 'Filled out contact data'
                            });
                        }}
                        sx={{margin: 1}} variant={"contained"}
                        disabled={
                            (
                                frmFn === '' ||
                                frmLn === '' ||
                                frmStreet === '' ||
                                frmCity === '' ||
                                frmEmail === '' ||
                                frmPhone === '' ||
                                !emailValid ||
                                !phoneValid ||
                                (emailConfirm === '' || frmEmail !== emailConfirm)
                            )
                        }
                >
                    Next: Add your animals
                </Button>
            </div>
            <Button size="full" variant={""}
                    onClick={() => setAStep(aStep - 1)}
                    sx={{margin: 1}}>Back
            </Button>
        </div>
    )
}
